//@flow

import React from 'react';
import isEmpty from 'lodash/isEmpty';

import SearchForm from './LodgeSearchForm';
import { Sticky, StaticSearchFormWrapper } from '../../../components';
import { getFromCookies, constructLabel } from '../helpers';
import { formatToShow } from '../../../lib/helpers';

type Props = {
  forMobile: boolean,
};

const renderForDesktop = () => (
  <Sticky>
    <section className="side__panel d-none d-xl-block">
      <h4>Search</h4>
      <SearchForm />
    </section>
  </Sticky>
);

const renderForMobile = ({ close }) => (
  <section className="side__panel">
    <h4>Search</h4>
    <SearchForm onSuccess={close} />
  </section>
);

LodgeSearchFormWrapper.defaultProps = {
  forMobile: false,
};

export default function LodgeSearchFormWrapper(props: Props) {
  const { forMobile } = props;
  const { pax, checkinDate, checkoutDate, queryName } = getFromCookies();

  return (
    <StaticSearchFormWrapper
      forMobile={forMobile}
      DesktopComponent={renderForDesktop}
      MobileComponent={renderForMobile}
      checkinDate={checkinDate}
      checkoutDate={checkoutDate}
      searchText={
        isEmpty(queryName) ? 'Where do you want to go?' : constructLabel(queryName)
      }
      pax={pax}
      dateText={
        checkinDate && checkoutDate
          ? `${formatToShow(checkinDate)} - ${formatToShow(checkoutDate)}`
          : 'No Dates Selected'
      }
    />
  );
}



// WEBPACK FOOTER //
// ./src/screens/Lodge/Common/LodgeSearchFormWrapper.js